import Service from "./Service";

class BlogService extends Service{

    async all(limit = 1, page = 1) {
        const data = new FormData();
        data.append('action', 'blogItems');
        data.append('data[limit]', limit);
        data.append('data[page]', page);

        const response = await fetch(this.baseUrl, {
            method: 'POST',
            body: data
        });

        if (response.status !== 200 && response.status !== 400) throw new Error('Ошибка при получении данных')

        return response.json();
    }
    async search(searchQuery = '',limit = 1, page = 1) {
        const data = new FormData();
        data.append('action', 'blogItemsBySearch');
        data.append('data[limit]', limit);
        data.append('data[page]', page);
        data.append('data[searchQuery]', searchQuery);

        const response = await fetch(this.baseUrl, {
            method: 'POST',
            body: data
        });

        if (response.status !== 200 && response.status !== 400) throw new Error('Ошибка при получении данных')

        return response.json();
    }

    async tags() {
        const data = new FormData();
        data.append('action', 'blogItemsCategory');
        data.append('data[action]', '1');

        const response = await fetch(this.baseUrl, {
            method: 'POST',
            body: data
        });

        if (response.status !== 200 && response.status !== 400) throw new Error('Ошибка при получении данных')

        return response.json();
    }

    async byTag(tagId = 1,limit = 1, page = 1,sorting = '') {
        const data = new FormData();
        data.append('action', 'blogItemsByTag');
        data.append('data[limit]', limit);
        data.append('data[page]', page);
        data.append('data[tagId]', tagId);
        data.append('data[sorting]', sorting);

        const response = await fetch(this.baseUrl, {
            method: 'POST',
            body: data
        });

        if (response.status !== 200 && response.status !== 400) throw new Error('Ошибка при получении данных')

        return response.json();
    }


}


export default new BlogService();